module.exports = __webpack_public_path__ + "img/video@2x.3cdbbe4.webp";